export default "__VITE_ASSET__CzFXwKpO__"